export default __webpack_public_path__ + "static/media/o-gif.d08d8386.gif";